/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2021, Bulb Inc.  For more information, please email contact@hellobulb.com.
 *
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
 *
 */

import { Component } from '@angular/core';
import { NgForm } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { MigratorStatus } from './migrator-status.model';

/**
 * Component to make API requests to run both named and default migrators, and also retrieve their status.
 */
@Component({
  selector: 'bulb-run-migrators',
  templateUrl: './run-migrators.component.html',
  styleUrls: ['./run-migrators.component.scss'],
  standalone: false,
})
export class RunMigratorsComponent {
  migratorStatuses: Array<MigratorStatus> = new Array<MigratorStatus>();

  runMigratorResponse: any;

  migratorStatusName: string = '';

  runMigratorName: string = '';

  /**
   * Default constructor.
   * @param http http client
   */
  constructor(private http: HttpClient) { }

  /**
   * Runs all default migrators
   */
  public runDefaultMigrators() {
    this.http.post('bootstrap/migrate', {})
      .toPromise()
      .then((response: any) => {
        this.runMigratorResponse = response.data;
      }, (response) => {
        if (response.status === 404) {
          this.runMigratorResponse = response.error;
        } else {
          console.log('There was an error with the request');
        }
      });
  }

  /**
   * Runs a named migrator by name
   *
   * @param event Form submission event that contains the migrator name to run
   */
  public runMigrators(event: NgForm) {
    if (event.form.value.runMigratorName.toLowerCase() === 'default') {
      this.runDefaultMigrators();
    } else {
      this.http.post(`bootstrap/migrate/${event.form.value.runMigratorName}`, {})
        .toPromise()
        .then((response : any) => {
          this.runMigratorResponse = response.data;
        }, (response) => {
          if (response.status === 404) {
            this.runMigratorResponse = response.error;
          } else {
            console.log('There was an error with the request');
          }
        });
    }
  }

  /**
   * Gets a named migrator status or the status of all default migrators
   *
   * @param event Form submission event that contains the migrator name to retrieve the status for
   */
  public getMigratorStatus(event: NgForm) {
    this.http.get(`bootstrap/migrate/${event.form.value.migratorStatusName}/status`)
      .toPromise()
      .then((response: any) => {
        this.migratorStatuses = response;
      });
  }
}
